import React, { useEffect } from 'react';
import { ConfigProvider } from 'antd';
import { getAntdTheme } from '../../shared/styles/antd-theme';
import { useAppSelector } from '../../shared/hooks/use-app-selector';
import antdGlobalStyles from '../../shared/styles/antd-global.css?useable';

export function AntdProvider({ children }: React.PropsWithChildren) {
  const currentMerchant = useAppSelector((state) => state.currentMerchant);

  const merchantId = currentMerchant?.id || '';
  const merchantSource = currentMerchant?.source || '';

  const antdTheme = getAntdTheme({ merchantId, merchantSource });

  useEffect(() => {
    antdGlobalStyles.use();

    return () => {
      antdGlobalStyles.unuse();
    };
  }, []);

  return (
    <ConfigProvider prefixCls="ant-v5" theme={antdTheme}>
      {children}
    </ConfigProvider>
  );
}
